import * as React from 'react';
import InputBox from 'src/components/shared/InputBox';
import CheckBox from 'src/components/shared/CheckBox';
// import DatePicker from 'src/components/shared/DatePicker';
import Tooltip from 'src/components/shared/Tooltip';
import { ProviderInfoPayment } from 'src/models/provider';
import { formatAddress } from 'src/utils/formater';
import { PaidPayment, PaymentProduct, PaymentProductService, PaymentProductType } from 'src/models/payment';
import { loadStripe } from '@stripe/stripe-js';
import { ElementsConsumer, Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import { validationRules } from './validationRules';
import { stripeKey } from 'src/appconfig';

interface Props {
    provider: ProviderInfoPayment;
    paidPayment: PaidPayment;
    triggerCheckError: boolean;
    submitting: boolean; // show loading
    paymentProducts: Array<PaymentProduct>;
    updatePaidProductService: (paidProductService: PaymentProductService) => void;
    handleChange: (value: string | number, field: string) => void;
    refCheckoutForm?: (el: CheckoutForm | null) => void;
}

interface State {
    paidProductService: PaymentProductService;
    priceOfACEHR: number;
    priceOfACScripts: number;
    priceOfACBilling: number;
}

// const InjectedCheckoutForm = () => (
//     <ElementsConsumer>
//         {({ stripe, elements }) => (
//             <CheckoutForm stripe={stripe} elements={elements} />
//         )}
//     </ElementsConsumer>
// );

const stripePromise = loadStripe(stripeKey.StripePublicKey || '');

class PaidProduct extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = this.getInitialState();
    }
    checkoutForm: CheckoutForm | null;

    getInitialState = (): State => {
        return {
            paidProductService: { ACEHR: false, ACScripts: true, ACBilling: false },
            priceOfACEHR: 0,
            priceOfACScripts: 0,
            priceOfACBilling: 0
        };
    }

    componentWillReceiveProps(nextProps: Props) {
        const { paymentProducts } = nextProps;
        if (paymentProducts && paymentProducts.length > 0) {
            let priceOfACEHR: number = paymentProducts.find(product => product.productName === PaymentProductType.ACEHR)?.amount ?? 0;
            let priceOfACScripts: number = paymentProducts.find(product => product.productName === PaymentProductType.ACScripts)?.amount ?? 0;
            let priceOfACBilling: number = paymentProducts.find(product => product.productName === PaymentProductType.ACBilling)?.amount ?? 0;
            this.setState({
                priceOfACEHR: priceOfACEHR,
                priceOfACScripts: priceOfACScripts,
                priceOfACBilling: priceOfACBilling
            });
        }
    }

    totalAmount = (paidProductService: PaymentProductService): number => {
        const { provider } = this.props;
        const { priceOfACEHR, priceOfACScripts, priceOfACBilling } = this.state;

        let amount: number = 0;

        if (paidProductService.ACEHR) {
            amount += priceOfACEHR;
        }
        if (paidProductService.ACScripts) {
            amount += priceOfACScripts;
        }
        if (paidProductService.ACBilling) {
            amount += priceOfACBilling;
        }

        if (provider.clinics) {
            const length = provider.clinics.length;
            if (provider && length > 0) {
                amount *= length;
            }
        }

        return amount;
    }

    handleChange = (value: string, field: string): void => {
        this.setState((prevState: State) => {
            const newServices: PaymentProductService = {
                ...prevState.paidProductService,
                [field]: value === '1' ? true : false
            };
            this.props.updatePaidProductService(newServices);

            return {
                ...prevState,
                paidProductService: newServices
            };
        });
    }

    handleRef = (el: CheckoutForm | null) => {
        this.checkoutForm = el;
        if (this.props.refCheckoutForm) {
            this.props.refCheckoutForm(el);
        }
    }

    render(): JSX.Element {
        const { paidPayment, provider, triggerCheckError, submitting } = this.props;
        const { paidProductService, priceOfACScripts /*priceOfACEHR, priceOfACScripts, priceOfACBilling*/ } = this.state;

        return (
            <React.Fragment>
                {
                    // submitting ?
                    // <div className="loading-center">
                    //     <table className="table table-borderless">
                    //         <tbody className="spinner-bg d-flex">
                    //             <tr className="text-center">
                    //                 <td className="alert alert-info" role="alert">
                    //                     <span className="alert-text"><span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />Submitting...</span>
                    //                 </td>
                    //             </tr>
                    //         </tbody>
                    //     </table>
                    // </div>
                    // :
                    <div className="col main-cont payment-products-type">
                        {/* <div className="flex-full card-sp"> */}
                        {/* <h5 className="card-title-sp">Paid Products</h5> */}
                        {/* <div className="card-cont-sp flex-full"> */}
                        <div className="fix-workspace">
                            <div className="autoscroll-1 border-cont" style={{ overflowX: 'auto' }}>
                                <form>
                                    <div className="form-group row">
                                        <label className="col-auto col-form-label">{`If you want to buy a product or all products, please check the product(s) you wish to buy and fill out your credit card information.
                                                \nPayment will be automatically withdraw from your credit card after 3 months free trial period.`}</label>
                                        {/* <label className="col-auto col-form-label">{`Control substance e-prescription is pending till summer 2022.`}</label> */}
                                    </div>
                                    {
                                        submitting &&
                                        <div className="loading-center">
                                            <table className="table table-borderless">
                                                <tbody className="spinner-bg d-flex">
                                                    <tr className="text-center">
                                                        <td className="alert alert-info" role="alert">
                                                            <span className="alert-text"><span className="spinner-border text-info spinner-border-md float-right" role="status" aria-hidden="true" />Submitting...</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">1. Price:</label>
                                        <div className="form-group">
                                            {/* <div className="col-auto">
                                                        <CheckBox
                                                            id="cbPaymentACEHR"
                                                            checked={paidProductService.ACEHR}
                                                            value={paidProductService.ACEHR ? '0' : '1'}
                                                            // onChange={this.handleChange}
                                                            onChange={() => { }}
                                                            field={PaymentProductType.ACEHR.toString()}
                                                            isCheckbox={true}
                                                            // label={`ACEHR: $${priceOfACEHR}/month\n`}
                                                            label={`ACEHR (Coming Soon)`}
                                                            extendClass="custom-control-inline"
                                                            extendLableClass="payment-checkbox-label"
                                                            disabled={true}
                                                        />
                                                    </div> */}
                                            <div className="col-auto">ACEHR (Coming Soon)</div>
                                            <div className="col-auto">
                                                <label className="col-form-label font-size-13-5">(per 1 provider per clinic)</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            {/* <div className="col-auto">
                                                        <CheckBox
                                                            id="cbPaymentACScripts"
                                                            checked={paidProductService.ACScripts}
                                                            value={paidProductService.ACScripts ? '0' : '1'}
                                                            // onChange={this.handleChange}
                                                            onChange={() => { }}
                                                            field={PaymentProductType.ACScripts.toString()}
                                                            isCheckbox={true}
                                                            // label={`ACScripts: $${priceOfACScripts}/month`}
                                                            label={`ACScripts: $40/month`}
                                                            extendClass="custom-control-inline"
                                                            extendLableClass="payment-checkbox-label"
                                                            disabled={true}
                                                        />
                                                    </div> */}
                                            <div className="col-auto">ACScripts: ${priceOfACScripts}/month</div>
                                            <div className="col-auto">
                                                <label className="col-form-label font-size-13-5">(per 1 provider per clinic)</label>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            {/* <div className="col-auto">
                                                        <CheckBox
                                                            id="cbPaymentACBilling"
                                                            checked={paidProductService.ACBilling}
                                                            // value={paidProductService.ACBilling ? '0' : '1'}
                                                            // onChange={this.handleChange}
                                                            value=""
                                                            onChange={() => { }}
                                                            field={PaymentProductType.ACBilling.toString()}
                                                            isCheckbox={true}
                                                            // label={`ACBilling: $${priceOfACBilling}/month`}
                                                            label={`ACBilling (Coming Soon)`}
                                                            extendClass="custom-control-inline"
                                                            extendLableClass="payment-checkbox-label"
                                                            disabled={true}
                                                        />
                                                    </div> */}
                                            <div className="col-auto">ACBilling (Coming Soon)</div>
                                            <div className="col-auto">
                                                <label className="col-form-label font-size-13-5">(per 1 provider per clinic)</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">2. Payment Account Name:</label>
                                        <div className="col-auto" style={{ pointerEvents: 'none' }}>
                                            <InputBox
                                                id="txtPaymentAccountName"
                                                extendClass={['', 'width300']}
                                                field="paymentAccountName"
                                                label="Payment Account Name"
                                                value={paidPayment.paymentAccountName}
                                                // value=""
                                                onChange={() => { }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">3. Credit Card Information:<span className="required-icon">*</span></label>
                                        <div className="col-auto col-sm-3">
                                            <Tooltip
                                                wrapper={''}
                                                title={''}
                                                className={''}
                                                isValidation={true}
                                            >
                                                <Elements stripe={stripePromise}>
                                                    {/* Injected CheckoutForm */}
                                                    <ElementsConsumer>
                                                        {({ stripe, elements }) => (
                                                            <CheckoutForm
                                                                ref={this.handleRef}
                                                                stripe={stripe}
                                                                elements={elements}
                                                                nameOnCard={paidPayment.creditCardName}
                                                            />
                                                        )}
                                                    </ElementsConsumer>
                                                    {/* <div className="form-control-clinics" style={{ height: '25.5px', width: '300px' }} /> */}
                                                </Elements>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">4. Credit Card Name:<span className="required-icon">*</span></label>
                                        <div className="col-auto col-sm-2">
                                            <InputBox
                                                id="txtCreditCardName"
                                                extendClass={['width300', 'width300']}
                                                field="creditCardName"
                                                label="Credit Card Name"
                                                // value=""
                                                value={paidPayment.creditCardName}
                                                rules={validationRules.creditCardName}
                                                onChange={this.props.handleChange}
                                                triggerCheckError={triggerCheckError}
                                            // onChange={() => { }}
                                            />
                                        </div>
                                    </div>

                                    {/* <div className="form-group row">
                                                <label className="col-sm-2 col-form-label">6. Expiration Date:<span className="required-icon">*</span></label>
                                                <div className="col-auto col-sm-2">
                                                    <DatePicker
                                                        id="dpExpDate"
                                                        extendClass={'width125'}
                                                        field="expirationDate"
                                                        label="Expiration Date"
                                                        value={paidPayment.expirationDate}
                                                        rules={validationRules.expirationDate}
                                                        onChange={this.props.handleChange}
                                                        triggerCheckError={triggerCheckError}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-2 col-form-label">7. Security Code:<span className="required-icon">*</span></label>
                                                <div className="col-auto col-sm-2">
                                                    <InputBox
                                                        id="txtSecurityCode"
                                                        extendClass={['width125', 'width125']}
                                                        // type="number"
                                                        field="securityCode"
                                                        label="Security Code"
                                                        value={paidPayment.securityCode}
                                                        rules={validationRules.securityCode}
                                                        onChange={this.props.handleChange}
                                                        triggerCheckError={triggerCheckError}
                                                    />
                                                </div>
                                            </div> */}

                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">5. Clinic Address:</label>
                                        <div className="col-auto col-sm-2">
                                            {
                                                provider != undefined && provider.clinics != undefined && provider.clinics.length > 0 ? provider.clinics.map((clinic, index) => (
                                                    <React.Fragment key={index}>
                                                        <div className="form-control-clinics width400">
                                                            {`${index + 1}. ` + formatAddress(clinic.addressLine1, clinic.city, null, clinic.state, clinic.zipCode)}
                                                            {/* Temporary updated on UI - TODO: Update this logic for each facility*/}
                                                            <div className="form-group row" style={{ marginLeft: '15px', }}>
                                                                <CheckBox
                                                                    id="cbPaymentACEHR"
                                                                    checked={paidProductService.ACEHR}
                                                                    value={paidProductService.ACEHR ? '0' : '1'}
                                                                    onChange={() => { }}
                                                                    field={PaymentProductType.ACEHR.toString()}
                                                                    isCheckbox={true}
                                                                    label={`ACEHR`}
                                                                    extendClass="custom-control-inline"
                                                                    extendLableClass="payment-checkbox-label"
                                                                    disabled={true}
                                                                />
                                                                <CheckBox
                                                                    id="cbPaymentACScripts"
                                                                    checked={paidProductService.ACScripts}
                                                                    value={paidProductService.ACScripts ? '0' : '1'}
                                                                    onChange={() => { }}
                                                                    field={PaymentProductType.ACScripts.toString()}
                                                                    isCheckbox={true}
                                                                    label={`ACScripts`}
                                                                    extendClass="custom-control-inline"
                                                                    extendLableClass="payment-checkbox-label"
                                                                    disabled={true}
                                                                />
                                                                <CheckBox
                                                                    id="cbPaymentACBilling"
                                                                    checked={paidProductService.ACBilling}
                                                                    value=""
                                                                    onChange={() => { }}
                                                                    field={PaymentProductType.ACBilling.toString()}
                                                                    isCheckbox={true}
                                                                    label={`ACBilling`}
                                                                    extendClass="custom-control-inline"
                                                                    extendLableClass="payment-checkbox-label"
                                                                    disabled={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )) : ''
                                            }

                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">6. Total Amount Charge:</label> {/* width175 */}
                                        <div className="col-auto col-sm-4" style={{ display: 'flex', pointerEvents: 'none' }}>
                                            <InputBox
                                                id="txttotalAmount"
                                                extendClass={['', 'width125']}
                                                field="totalAmount"
                                                label="Total Amount"
                                                value={'$ ' + this.totalAmount(paidProductService).toString()}
                                                // value=""
                                                onChange={() => { }}
                                            />
                                            <label className="col-auto col-form-label">per month</label>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* </div> */}
                        {/* </div> */}
                    </div>
                }
            </React.Fragment>
        );
    }
}

export default PaidProduct;


// WEBPACK FOOTER //
// ./src/components/Payment/PaidProduct.tsx